// Desktop prism mega menu behavior (snippets/meganav-prism.liquid).
//
// Mouse: hovering a top-level item for OPEN_DELAY opens its panel (the delay
// prevents accidental opens when rolling across the bar); clicking the item
// navigates to its collection. Keyboard: Enter opens the panel, Enter again
// navigates. Touch (no hover): first tap opens, second tap navigates.
// One panel open at a time; closes on outside click / Escape / focus leaving.
(function () {
  var OPEN_DELAY = 350;
  var CLOSE_DELAY = 250;

  var nav = document.querySelector('.site-navigation-wrapper');
  if (!nav) return;

  var items = Array.prototype.slice.call(nav.querySelectorAll('[data-prism-details]'));
  if (!items.length) return;

  var hoverCapable = window.matchMedia('(hover: hover)').matches;

  function closeAll(except) {
    items.forEach(function (details) {
      if (details !== except && details.open) details.open = false;
    });
  }

  items.forEach(function (details) {
    var summary = details.querySelector('[data-prism-summary]');
    var openTimer = null;
    var closeTimer = null;

    details.addEventListener('toggle', function () {
      if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (details.open) closeAll(details);
    });

    if (summary && summary.dataset.href) {
      summary.addEventListener('click', function (e) {
        var isMouseClick = hoverCapable && e.detail > 0;
        if (isMouseClick || details.open) {
          e.preventDefault();
          window.location.href = summary.dataset.href;
        }
        // Otherwise (keyboard with panel closed, or first tap on touch):
        // let the native <details> toggle open the panel
      });
    }

    if (hoverCapable) {
      details.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        clearTimeout(closeTimer);
        if (!details.open) {
          openTimer = setTimeout(function () {
            details.open = true;
          }, OPEN_DELAY);
        }
      });
      details.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'touch') return;
        clearTimeout(openTimer);
        if (details.open) {
          closeTimer = setTimeout(function () {
            details.open = false;
          }, CLOSE_DELAY);
        }
      });
    }

    // Start fetching the panel's images as soon as the cursor reaches the
    // menu item, so they're ready by the time the panel opens
    if (summary) {
      summary.addEventListener('pointerenter', function () {
        details.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
        });
      }, { once: true });
    }
  });

  document.addEventListener('click', function (e) {
    if (!nav.contains(e.target)) closeAll();
  });

  nav.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;
    var open = items.filter(function (d) { return d.open; })[0];
    if (open) {
      closeAll();
      var summary = open.querySelector('[data-prism-summary]');
      if (summary) summary.focus();
    }
  });

  nav.addEventListener('focusout', function (e) {
    if (e.relatedTarget && !nav.contains(e.relatedTarget)) closeAll();
  });
})();
